// PATH: src/components/common/ConfirmDialog.jsx
// VERSION: 1.0 — useConfirm()

import React, { createContext, useContext, useState, useCallback } from 'react';
import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button
} from '@chakra-ui/react';

const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false });

  const confirm = useCallback(({ title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', colorScheme = 'blue' }) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        colorScheme,
        resolve,
      });
    });
  }, []);

  const onClose = useCallback(() => {
    setState((s) => (s.open ? (s.resolve?.(false), { open: false }) : s));
  }, []);

  const onConfirm = useCallback(() => {
    setState((s) => (s.open ? (s.resolve?.(true), { open: false }) : s));
  }, []);

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      <AlertDialog isOpen={state.open} leastDestructiveRef={undefined} onClose={onClose}>
        <AlertDialogOverlay />
        <AlertDialogContent>
          {state.title && <AlertDialogHeader>{state.title}</AlertDialogHeader>}
          {state.message && <AlertDialogBody>{state.message}</AlertDialogBody>}
          <AlertDialogFooter>
            <Button onClick={onClose} mr={3}>{state.cancelText || 'Cancelar'}</Button>
            <Button colorScheme={state.colorScheme || 'blue'} onClick={onConfirm}>
              {state.confirmText || 'Confirmar'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmCtx.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmCtx);
  if (!ctx) throw new Error('useConfirm debe usarse dentro de <ConfirmProvider>');
  return ctx;
}
